import { useAdminLogin } from './useAdminLogin'
import { useAdminLogout } from './useAdminLogout'
import type { UseAdminAuthParams } from './useAdminAuth.types'

export const useAdminAuth = (params: UseAdminAuthParams) => {
  const handleLogin = useAdminLogin(params)
  const logout = useAdminLogout(params)

  return {
    handleLogin,
    logout,
  }
}
